"use client";

import { Search } from "lucide-react";

import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";

import { useGlobalSearchContext } from "./global-search-context";

interface GlobalSearchTriggerProps {
  className?: string;
  compact?: boolean;
}

export function GlobalSearchTrigger({
  className,
  compact = false,
}: GlobalSearchTriggerProps) {
  const { setOpen } = useGlobalSearchContext();

  return (
    <Button
      type="button"
      variant="outline"
      onClick={() => setOpen(true)}
      className={cn(
        "relative h-9 justify-start gap-2 border-transparent bg-muted/70 text-sm font-normal text-muted-foreground shadow-none hover:bg-muted",
        compact ? "w-9 px-0 justify-center" : "w-full max-w-md",
        className
      )}
    >
      <Search className="h-4 w-4 shrink-0" />
      {!compact ? (
        <>
          <span className="flex-1 text-left">Search Workspace</span>
          <kbd className="pointer-events-none hidden h-5 select-none items-center gap-1 rounded border bg-background px-1.5 font-mono text-[10px] font-medium text-muted-foreground sm:inline-flex">
            <span className="text-xs">⌘</span>K
          </kbd>
        </>
      ) : null}
    </Button>
  );
}
